export interface StatisticCell {
  readonly value: number | string | Date | null;
  readonly numFmt?: string;
}

export interface StatisticCells {
  readonly value: StatisticCell;
  readonly percent: StatisticCell;
}

const createNumericCell = (
  value: number | null | undefined,
  numFmt: string,
): StatisticCell =>
  typeof value === 'number' && Number.isFinite(value)
    ? { value, numFmt }
    : { value: '—' };

const calculateRatio = (
  numerator: number,
  denominator: number | null | undefined,
): number | null =>
  typeof denominator === 'number' &&
  Number.isFinite(denominator) &&
  denominator !== 0
    ? numerator / denominator
    : null;

export const createStatisticCountCell = (
  value: number | null | undefined,
): StatisticCell => createNumericCell(value, '#,##0');

export const createStatisticPercentCell = (
  numerator: number,
  denominator: number | null | undefined,
  decimals = 2,
): StatisticCell =>
  createNumericCell(
    calculateRatio(numerator, denominator),
    `0.${'0'.repeat(decimals)}%`,
  );

export const createStatisticRatioCell = (
  numerator: number,
  denominator: number | null | undefined,
): StatisticCell =>
  createNumericCell(calculateRatio(numerator, denominator), '0.0');
